import React from "react"
import Layout from "../components/layout"

export default () => (
<Layout>
  <div class="container desc">
    <div class="row">

        <div class="col-lg-2 col-lg-offset-1">
          <h5><b>Binit!</b></h5>
          <p><t>As part of Columbia’s urban works design challenge, I teamed up with four friends to develop an automated trash can. Using computer vision through the Google Cloud Vision API, as well as sensor technology, we are developing a trash reciptical which is able to segregate recyclables and non-recyclables on its own. 
          After presenting the idea to Columbia professors, we were selected as finalists in this competition. We are going to be attending a trip to India in January 2019 to conduct market research and further customer discovery. Stay tuned for more updates! <br></br><a href="https://jbbollas.wixsite.com/binit">binit.in</a></t><br/>
          </p>
        </div>
         <div class="col-lg-2 col-lg-offset-1">
          <h5><b>Analysis of Influenza A Proton Kinetics through Mathematical/Biochemical Modelling</b></h5>
          <p><t>In high school, I did research on the infection pathway of the Influenza A virus. I developed a mathematical model of how influenza enters the cell using R and Excel.
          I co-authored a research paper regarding the work I did, and am in the process of getting it published.</t><br/>
          </p>
        </div>
         <div class="col-lg-2 col-lg-offset-1">
          <h5><b>Mining Novel RNA Sequences -- An Effort to Further Map the Human Transcriptome</b></h5>
          <p><t>After being accepted into the Rockefeller Summer Science Research Program, I worked in the Tuschl Lab of RNA molecular biology on a project called <i>Anvesana</i>.
          We were building a database of RNA transcripts to help better understand the human transcriptome. Over the summer of my Junior year, I worked on creating a user interface
          for this database that allows easy and efficient access to the data. Over the next year, I helped develop a protocol for mining datasets of RNA sequencing experiments for 
          	novel, alternatively spliced, RNA transcripts. I presented my work to other Rockefeller University Professors, as well as at the St. Luke's School scholars symposium. See below for a video of my presentation!
          </t><br/>
          </p>
        </div>


        <iframe src="https://player.vimeo.com/video/280236343?color=96eaff&title=0&byline=0&portrait=0" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>

    </div>
    </div>
  </Layout>
)